<!-- 地图 -->
<template>
  <div class="centerMapContent">
    <div id="centermap" class="homepage-map"></div>
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="4">
        <div class="grid-content bg-purple">
          <p class="warn-name">雨量1h超警</p>
          <p class="warn-num"><b>2</b></p>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content bg-purple">
          <p class="warn-name">雨量3h超警</p>
          <p class="warn-num"><b>1</b></p>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content bg-purple">
          <p class="warn-name">水库超汛限</p>
          <p class="warn-num"><b>3</b></p>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content bg-purple">
          <p class="warn-name">河道水位超警</p>
          <p class="warn-num"><b>2</b></p>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="grid-content bg-purple">
          <p class="warn-name">预警村落</p>
          <p class="warn-num"><b>4</b></p>
        </div>
      </el-col>
    </el-row>
    <el-row v-if="showLegend" :gutter="20" class="row-bg row-legend">
      <el-col :span="22"  style="position:relative;">
        <div class="grid-content bg-purple legend"></div>
        <span @click="showLegend = false, hiddenLegend = true" class="legend-closed">×</span>
      </el-col>
    </el-row>
    <div v-if="hiddenLegend" class="show-legend" @click="showLegend = true, hiddenLegend = false"></div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import * as L from 'leaflet'
import icon from 'leaflet/dist/images/marker-icon.png'
import iconShadow from 'leaflet/dist/images/marker-shadow.png'
import request from '@/utils/request'
require('../../assets/map/leaflet.ChineseTmsProviders.js')
let DefaultIcon = L.icon({
  iconUrl: icon,
  shadowUrl: iconShadow
})
L.Marker.prototype.options.icon = DefaultIcon
export default {
  name: 'centermap',
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
  // 这里存放数据
    return {
      showLegend: true,
      hiddenLegend: false,
      waterLevelData: [
        {
          name: '地点1',
          originalWaterLevel: '20', // 原始水位
          currentLevel: '30', // 当前水位
          latLng: [30.076697, 120.470071]
        }, {
          name: '地点2',
          originalWaterLevel: '50',
          currentLevel: '35',
          latLng: [30.099697, 120.473521]
        }, {
          name: '地点3',
          originalWaterLevel: '40',
          currentLevel: '40',
          latLng: [29.993655, 120.432127]
        }, {
          name: '地点4',
          originalWaterLevel: '50',
          currentLevel: '80',
          latLng: [30.19164, 120.563208]
        }
      ]
    }
  },
  // 监听属性 类似于data概念
  computed: {
    mapSize () {
      let styleObj = {
        width: this.mapWidth,
        height: this.mapHeight
      }
      return styleObj
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    leaflet () {
      var normalm = L.tileLayer.chinaProvider('TianDiTu.Normal.Map', {
        maxZoom: 18,
        minZoom: 5
      })
      var normala = L.tileLayer.chinaProvider('TianDiTu.Normal.Annotion', {
        maxZoom: 18,
        minZoom: 5
      })
      var imgm = L.tileLayer.chinaProvider('TianDiTu.Satellite.Map', {
        maxZoom: 18,
        minZoom: 5
      })
      var imga = L.tileLayer.chinaProvider('TianDiTu.Satellite.Annotion', {
        maxZoom: 18,
        minZoom: 5
      })
      var normal = L.layerGroup([normalm, normala])
      var image = L.layerGroup([imgm, imga])
      var baseLayers = {
        '影像': image,
        '地图': normal
      }
      var overlayLayers = {}
      var map = L.map('centermap', {
        center: [29.971, 120.537],
        zoom: 10,
        layers: [image],
        zoomControl: false
      })
      L.control.layers(baseLayers, overlayLayers).addTo(map)
      L.control.zoom({
        zoomInTitle: '放大',
        zoomOutTitle: '缩小'
      }).addTo(map)
      // 渲染GeoJson
      var myStyle = {
        'color': '#2dd9f8',
        'weight': 3,
        'opacity': 1
      }
      request.get('https://' + window.location.host + '/yjjson/yongjiaTown.json').then(res => {
        L.geoJSON(res.data, {
          style: myStyle
        }).addTo(map)
      })
      // 处理标记数据
      this.addMarker(map)
    },
    // 添加标记点
    addMarker (map) {
      this.waterLevelData.forEach((item, index) => {
        console.log(this.waterLevelData)
        // 定义icon类以创建一组图标使用相同属性的图标
        var LeafIcon = L.Icon.extend({
          options: {
            iconSize: [38, 95],
            shadowSize: [50, 64],
            iconAnchor: [22, 94],
            shadowAnchor: [4, 62],
            popupAnchor: [-3, -76]
          }
        })
        var markerDown = new LeafIcon({
          iconUrl: '../../assets/map/images/water-down.png',
          shadowUrl: '../../assets/map/images/water-down.png'
        })
        var markerUp = new LeafIcon({
          iconUrl: '../../assets/map/images/water-up.png',
          shadowUrl: '../../assets/map/images/water-up.png'
        })
        var markerNormal = new LeafIcon({
          iconUrl: '../../assets/map/images/water-normal.png',
          shadowUrl: '../../assets/map/images/water-normal.png'
        })
        var markerUpWarn = new LeafIcon({
          iconUrl: '../../assets/map/images/water-up-warn.png',
          shadowUrl: '../../assets/map/images/water-up-warn.png'
        })
        var waterLevelDiff = item.originalWaterLevel - item.currentLevel
        if (waterLevelDiff >= 5) {
          // console.log('大于5')
          L.marker(item.latLng, { icon: markerUp }).addTo(map)
        } else if (waterLevelDiff > 0 && waterLevelDiff < 5) {
          // console.log('大于0小于5')
          L.marker(item.latLng, { icon: markerUpWarn }).addTo(map)
        } else if (waterLevelDiff < 0) {
          // console.log('小于0')
          L.marker(item.latLng, { icon: markerDown }).addTo(map)
        } else if (waterLevelDiff === 0) {
          // console.log('相等')
          L.marker(item.latLng, { icon: markerNormal }).addTo(map)
        }
      })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.leaflet()
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
@import url('../../assets/map/leaflet.css');
 .centerMapContent{
   width:100%;
   height: 845px;
   position: relative;
 }
 #centermap{
    width:100%;
    height: 845px;
    position: relative;
  }
  .mapboxgl-control-container{
    display: none;
  }
  .el-row {
    margin-bottom: 20px;
  }
  .el-row:last-child {
      margin-bottom: 0;
    }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background:rgba(162,44,25,.6);
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
    height: 100%;
  }
  .row-bg {
    padding: 10px 0;
    position: absolute;
    width: 100%;
    height: 85px;
    top: 0;
    z-index: 9999;
  }
  .warn-name{
    width: 100%;
    height: 20px;
    font-size: 16px;
    text-align: center;
    color: #fff;
    margin: 0;
    padding: 15px 0;
  }
  .warn-num{
    width: 100%;
    height: 20px;
    text-align: center;
    color: #ffff00;
    font-size: 24px;
    margin: 0;
    padding: 5px 0;
    font-style:italic;
    font-weight: 900
  }
  .row-legend{
    width: 185px;
    height: 290px;
    bottom: 0;
    top: auto;
    left: 10px;
    z-index: 9999;
  }
  .legend{
    height: 270px;
    background:none;
    background-image: url(../../assets/homepage_img/legend.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .legend-closed{
    width: 10px;
    height: 10px;
    padding: 0;
    line-height: 12px;
    position: absolute;
    color: #FFF;
    top: 5px;
    right: 15px;
    cursor: pointer;
  }
  .show-legend{
    width: 15px;
    height: 15px;
    background: rgba(162,44,25,.8);
    background-image: url(../../assets/homepage_img/openLegend.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: absolute;
    bottom: 265px;
    border-radius: 0 10px 10px 0;
    cursor: pointer;
    z-index: 9999;
  }
</style>
<style>
  /* 首页地图样式覆盖 */
  /* 地图按钮 */
  .homepage-map .leaflet-top{
    top: 80px;
  }
  .homepage-map .leaflet-bottom{
    display: none;
  }
</style>
